<template>
  <div class="elencotipomanufattoadd">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Registra una tipologia di manufatto</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="nome" v-model="formData.manufatto.nome" type="text" :state="state.nome" placeholder="Nome della tipologia di manufatto" /><label for="nome">Nome *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.manufatto.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>MODELLI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="9" offset="5">
          <b-button variant="success" size="lg" v-on:click="modal.modello=true"><font-awesome-icon icon="plus-circle" /> Aggiungi modello</b-button>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="formData.manufatto.modelli"
            :fields="campi"
            :current-page="currentPage.main"
            :per-page="perPage"
          >
            <template slot="action" slot-scope="row">
              <b-button size="sm" variant="danger" v-on:click="removeModello(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows.main"
            :per-page="perPage"
            v-model="currentPage.main"
            align="center"
          />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="addTipomanufatto()"><font-awesome-icon icon="plus-circle" /> Crea</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>

    <b-modal v-model="modal.modello" size="xl" title="Seleziona modelli da aggiungere">
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage.modal"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button v-if="!row.item.selected" size="sm" variant="success" v-on:click="addModello(row.item)"><font-awesome-icon icon="plus" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows.modal"
            :per-page="perPage"
            v-model="currentPage.modal"
            align="center"
          />
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" v-on:click="modal.modello = false">Fatto</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'elencotipomanufattoadd',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'descrizione', label: 'Modello', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: {
        main: 0,
        modal: 0
      },
      currentPage: {
        main: 1,
        modal: 1
      },
      perPage: 10,
      filter: null,
      
      state: {
        nome: null,
        note: null
      },
      formData:{
        manufatto: {
          nome: '',
          note: '',
          modelli: []
        }
      },
      modal: {
        modello: false
      }
    }
  },
  created: function(){
    this.getListaModello()
  },
  methods: {
    addModello(item){
      var index = this.lista.indexOf(item)
      this.lista[index].selected = true
      this.$set(this.lista, index, this.lista[index])
      this.formData.manufatto.modelli.push(this.lista[index])
      this.totalRows.main = this.formData.manufatto.modelli.length
    },
    removeModello(item){
      var index = this.formData.manufatto.modelli.indexOf(item)
      this.formData.manufatto.modelli[index].selected = false
      this.formData.manufatto.modelli = this.formData.manufatto.modelli.filter((e, indexE) => {
        if(index == indexE)
          return false
        return true
      })
      if(this.currentPage.main != 1)
        this.currentPage.main--

      this.totalRows.main = this.formData.manufatto.modelli.length
    },
    getListaModello(){
      Vue.http.post('selectlist/modelli', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.list
            this.totalRows.modal = this.lista.length

            for(var i=0; i<this.totalRows.modal; i++){
              this.lista[i].selected = false
            }
        }else{
          this.lista = []
          /*Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista Tipologie di alimentazione elettrica non caricata correttamente.",
              type: 'error'
          })*/
        }
      }, response => {})
    },
    addTipomanufatto(){
      Vue.http.post('elenco/tipomanufatto/add', this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Tipologia di manufatto aggiunto con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/tipomanufatto')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la registrazione',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows.modal = filteredItems.length
      this.currentPage = 1
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>

<style scoped>
#nome{
  text-indent: 85px;
}

#note{
  text-indent: 60px;
  line-height: 1.8;
}
</style>